export const alt = "Arpinet mobile tv application";

export const navbar = [
  {
    id: "1",
    title: "Հեռուստաալիքներ",
  },
  {
    id: "2",
    title: "Ինտերնետ",
  },
  {
    id: "4",
    title: "Հասանելիություն",
  },
  {
    id: "5",
    title: "Կապ",
  },
];

export const footer = [
  {
    id: "1",
    title: "Ինտերնետ",
  },
  {
    id: "2",
    title: "Հեռուստաալիքներ",
  },
  {
    id: "3",
    title: "Հասանելիություն",
  },
  {
    id: "4",
    title: "Կապ",
  },
  {
    id: "5",
    title: "Փաստաթղթեր",
  },
];
// <-- տարիֆներ -->

// CATV և Ինտերնետ
export const tvandinternet = [
  {
    id: "1",
    cat: "catv",
    price: "5900",
    speed: "80",
    channels: "104",
    wifi: true,
    title: "Կարմիր",
  },
  {
    id: "2",
    cat: "catv",
    price: "6900",
    speed: "100",
    channels: "104",
    wifi: true,
    title: "Կապույտ",
  },
  {
    id: "3",
    cat: "catv",
    price: "8900",
    speed: "150",
    channels: "104",
    wifi: true,
    title: "Ծիրանագույն",
  },
];

// օպտիկամանրաթելային ինտերնետ
export const fiberinternet = [
  {
    id: "1",
    cat: "fiber",
    price: "4900",
    speed: "50",
    wifi: true,
    title: "Econom",
  },
  {
    id: "2",
    cat: "fiber",
    price: "5900",
    speed: "80",
    wifi: true,
    title: "Standart",
  },
  {
    id: "3",
    cat: "fiber",
    price: "7900",
    speed: "120",
    wifi: true,
    title: "Ultra",
  },
  {
    id: "4",
    cat: "fiber",
    price: "11900",
    speed: "200",
    wifi: true,
    title: "Premium",
  },
];

// իրավաբանական անձանց համար (corporate)
export const corporateinternet = [
  {
    id: "1",
    cat: "corporate",
    price: "12000",
    speed: "100",
    wifi: true,
    title: "Ա+",
  },
  {
    id: "2",
    cat: "corporate",
    price: "15000",
    speed: "150",
    wifi: true,
    title: "Բ+",
  },
];

// Հետադարձ կապ
export const phoneNumbers = [
  {
    id: 0,
    number: "060 666 999",
    lnumber: "+37460666999",
    mode: "tel",
  },
  {
    id: 1,
    number: "091 19 52 65",
    lnumber: "+37491195265",
    mode: "tel",
  },
  {
    id: 2,
    number: "094 19 52 65",
    lnumber: "+37494195265",
    mode: "tel",
  },
  {
    id: 3,
    number: "055 19 52 65",
    lnumber: "+37455195265",
    mode: "tel",
  },
  {
    id: 4,
    number: "info@realtime.am",
    lnumber: "info@realtime.am",
    mode: "mailto",
  },
  {
    id: 5,
    number: "hr@realtime.am",
    lnumber: "hr@realtime.am",
    mode: "mailto",
  },
];
